import { FC } from 'react'

import { Box, Circle, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { useFinancialWorkspace } from 'modules/finance/components/FinancialWorkspace/Providers/Provider'
import { LineChart } from 'modules/finance/components/FinancialWorkspace/components/chart'
import { centToFormattedAmount } from 'modules/finance/components/FinancialWorkspace/components/chart/helpers'

import * as styles from './index.vanilla.css'

const CHART_DATA = [
  {
    serieId: 'agreementData',
    data: [
      {
        x: 'Jan 2025',
        title: 'Jan 2025',
        y: 3129570,
      },
      {
        x: 'Feb 2025',
        title: 'Feb 2025',
        y: 3166667,
      },
      {
        x: 'Mar 2025',
        title: 'Mar 2025',
        y: 3966667,
      },
      {
        x: 'Apr 2025',
        title: 'Apr 2025',
        y: 3966667,
      },
      {
        x: 'May 2025',
        title: 'May 2025',
        y: 3966667,
      },
      {
        x: 'Jun 2025',
        title: 'Jun 2025',
        y: 3966667,
      },
      {
        x: 'Jul 2025',
        title: 'Jul 2025',
        y: 3966667,
      },
      {
        x: 'Aug 2025',
        title: 'Aug 2025',
        y: 3801075,
      },
      {
        x: 'Sep 2025',
        title: 'Sep 2025',
        y: 4204167,
      },
      {
        x: 'Oct 2025',
        title: 'Oct 2025',
        y: 4266667,
      },
      {
        x: 'Nov 2025',
        title: 'Nov 2025',
        y: 4266667,
      },
      {
        x: 'Dec 2025',
        title: 'Dec 2025',
        y: 4266667,
      },
    ],
    pointColor: 'rgba(135, 127, 237, 1)',
    hoveredPointColor: 'rgba(30, 30, 49, 1)',
  },
]

export const UpsellChart: FC<{ title: string; cta?: React.ReactNode }> = ({ title, cta }) => {
  const { formattedState: variables } = useFinancialWorkspace()
  const {
    access: { locale: accessLocale },
    company: { currency },
  } = useCurrentSession()

  const toAmount = (value: number) => {
    const cents = Number(value) || 0
    return centToFormattedAmount(cents, accessLocale, currency)
  }

  return (
    <Box
      position="relative"
      width="full"
      height="s300"
      padding="s16"
      borderRadius={{ all: 'abs016' }}
      border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
    >
      <Box flexDirection="row" gap="s8" alignItems="center">
        <Circle type="viridian" size={10} />

        <Text.Normal weight="medium" size="200">
          {title}
        </Text.Normal>
      </Box>
      <Box className={styles.upsellChartBlurred} width="full" height="full">
        <Box paddingLeft="s16">
          <Text.Normal color="grey1000" weight="bold" size="300">
            {toAmount(1000000).amount}
          </Text.Normal>
        </Box>
        <LineChart
          loading={false}
          toAmount={toAmount}
          chartData={CHART_DATA}
          period={variables.period}
        />
      </Box>
      {cta && (
        <Box
          position="absolute"
          width="full"
          height="full"
          justifyContent="center"
          alignItems="center"
          className={styles.ctaOverlay}
        >
          {cta}
        </Box>
      )}
    </Box>
  )
}
